import { Box, TextField } from "@mui/material";
import React, { useState } from "react";
import PageTitle from "../../../widgets/PageTitle";
import MediaSelector from "../../../widgets/MediaSelector";
import WabaTextMsg from "../../../widgets/WabaTextMsg";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import { toast } from "react-toastify";
import axios from "axios";
import { API_ENDPOINT } from "../../../utils/constants";
import { getHeader, toastError } from "../../../utils/util";
import SaveButton from "./SaveButton";
const MediaMessage = (props) => {
  const {
    type: MediaType = "",
    value = {},
    isEdit = false,
    editId,
    preview,
    onUpdate,
  } = props;
  const type = isEdit ? value?.type : MediaType;
  const [caption, setCaption] = useState(value?.caption ?? "");
  const [mediaUrl, setMediaUrl] = useState(value?.link ?? "");
  const [fileName, setFileName] = useState(value?.filename ?? "");
  const [reply, setReply] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [resetTrue, setResetTrue] = useState(false);

  const handleSubmit = async () => {
    if (!mediaUrl) {
      toast.error(`Please select ${type}`);
      return;
    }
    if (!reply && !isEdit && !preview) {
      toast.error(`Reply text is required!`);
      return;
    }
    const payload = {
      type,
      link: mediaUrl,
    };
    if (caption) {
      payload.caption = caption;
    }
    if (fileName) {
      payload.filename = fileName;
    }
    const payloadObject = { ...payload };
    if (isEdit) {
      payloadObject.id = editId;
      payloadObject.isEdit = true;
    } else {
      payloadObject.triggerText = reply;
    }
    if (preview) {
      onUpdate?.(payload);
      return;
    }

    try {
      setSubmitting(true);
      const response = await axios.post(
        `${API_ENDPOINT}/message/save-message`,
        payloadObject,
        getHeader()
      );
      toast.success(response.data.message);
      resetFields();
    } catch (error) {
      toastError(error);
    } finally {
      setSubmitting(false);
    }
  };
  function resetFields() {
    setMediaUrl("");
    setCaption("");
    setFileName("");
    setReply("");
    setResetTrue(true);
  }
  return (
    <Box px={3}>
      <PageTitle>{type.toUpperCase()} message</PageTitle>
      <Box my={2}>
        <MediaSelector
          type={type}
          resetTrue={resetTrue}
          onChange={(newV) => {
            setMediaUrl(newV);
          }}
        />
        <WabaTextMsg
          label={`${type} caption`}
          my={2}
          value={caption}
          onChange={(newV) => {
            setCaption(newV);
          }}
        />

        {type === "document" && (
          <TextField
            fullWidth
            sx={{ my: 2 }}
            label="File Name"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
            variant="outlined"
            size="small"
          />
        )}
        {!preview ? (
          <TextField
            fullWidth
            sx={{ my: 2 }}
            label="Reply text"
            value={reply}
            disabled={isEdit}
            onChange={(e) => setReply(e.target.value)}
            variant="outlined"
            size="small"
          />
        ) : (
          <></>
        )}
        <SaveButton loading={submitting} onClick={handleSubmit} />
      </Box>
    </Box>
  );
};

export default MediaMessage;
